import { CardMedia, Container, Grid } from '@mui/material'

import bg from "assets/images/bg_hut_buton.jpeg"
import { AccountBalance, Check, List, Sync } from '@mui/icons-material'
import InfographicCard from 'examples/Cards/InfoCards/InfographicCard'
import { useEffect, useState } from 'react'
import { postDataWithResponse } from 'global/postFunc'
// import getMAC from 'getmac'

const Home = () => {
    const userAgent = window.navigator.userAgent;
    const platform = window.navigator.platform;
    const randomString = Math.random().toString(20).substring(2, 14) + Math.random().toString(20).substring(2, 14);

    const deviceID = `${userAgent}-${platform}-${randomString}`;

    useEffect(() => {
        console.log(deviceID);
        // console.log(getMAC('eth0'))
    }, [])

    const [data, setData] = useState([])
    const [loading, setLoading] = useState(false)
    const [totalOpd, setTotalOpd] = useState(0)

    const currentYear = new Date().getFullYear();

    const reqBelanja = () => {
        setLoading(true)
        postDataWithResponse(
            '/komponen-belanja/rekapitulasi',
            {
                ta: currentYear,
                // pagination: pagination,
                // globalFilter: globalFilter,
                // sorting: sorting,
                // columnFilter: columnFilter
            },
            null,
            (res) => {
                console.log(res);
                setData(res)
                setLoading(false)
            },
            (res) => {
                console.log(res)
                setLoading(false)
            }

        )
    }

    const reqOpd = () => {
            setLoading(true)
            postDataWithResponse(
                '/opd/filter',
                {
                    jenis: '',
                    nama: '',
                },
                null,
                (res) => {
                    console.log(res);
                    setTotalOpd(res.length)
                    setLoading(false)
                },
                (res) => {
                    console.log(res)
                    setLoading(false)
                }
    
            )
        }

    useEffect(() => {
        reqOpd()
        reqBelanja()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <Grid container>
            <Grid item xs={12}>
                <CardMedia
                    component="img"
                    alt="green iguana"
                    // height="140"
                    image={bg}
                    sx={{
                        height: 'auto',
                        width: '100%',
                        borderRadius: '0px',
                        margin: '0px'
                    }}
                />
            </Grid>
            <Container sx={{ my: 3 }}>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={6} xl={3}>
                        <InfographicCard
                            bgColor='dark'
                            color="white"
                            icon={<AccountBalance color='dark' />}
                            title="JUMLAH OPD"
                            // description="fjghdskfji"
                            value={totalOpd + ""}
                        />
                    </Grid>
                    <Grid item xs={12} md={6} xl={3}>
                        <InfographicCard
                            bgColor='white'
                            color="error"
                            icon={<List color='white' />}
                            title="TOTAL KEGIATAN"
                            // description="fjghdskfji"
                            value={data.total + ""}
                        />
                    </Grid>
                    <Grid item xs={12} md={6} xl={3}>
                        <InfographicCard
                            bgColor='info'
                            color="white"
                            icon={<Sync color='info' />}
                            title="KEGIATAN TERLAKSANA"
                            // description="fjghdskfji"
                            value={data.proses + ""}
                        />
                    </Grid>
                    <Grid item xs={12} md={6} xl={3}>
                        <InfographicCard
                            bgColor='success'
                            color="white"
                            icon={<Check color='success' />}
                            title="SELESAI"
                            // description="fjghdskfji"
                            value={data.selesai + ""}
                        />
                    </Grid>
                </Grid>
            </Container>
        </Grid>
    )
}

export default Home